import { parse } from 'date-fns'

import { getAvailability } from './getAvailability'
import { newestToOldest } from './newestToOldest'

export const getFirstAvailable = filteredAppointments => {
  if (filteredAppointments.length === 0) return null

  const sortedAppointments = filteredAppointments.toSorted(newestToOldest)

  const firstAvailableDay = parse(
    sortedAppointments[0].date,
    'yyyy-MM-dd',
    new Date()
  )

  const availability = getAvailability(firstAvailableDay, filteredAppointments)

  return {
    date: new Date(firstAvailableDay),
    times: availability?.times,
  }
}
